import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useDisabled(): [boolean] {
  return [useWebChatAPIContext().disabled];
}
